import React, { useState } from "react";

import compact from "lodash/compact";
import each from "lodash/each";

import { isNullOrEmpty } from "../../../utils/utils";
import Tab, { IProps as ITabProps } from "./tab";

import style from "./tabbar.module.scss";

interface IProps {
	style?: React.CSSProperties;
	tabBarStyle?: React.CSSProperties;
	tabStyle?: React.CSSProperties;
	children: React.ReactElement<ITabProps>[];
}

const TabPanel: React.FC<IProps> = (props: IProps) => {
	const [selectedTab, setSelectedTab] = useState(0);

	const cleanChildren: React.ReactElement<ITabProps>[] = compact(props.children);
	const tabs: JSX.Element[] = [];
	const panels: JSX.Element[] = [];

	each(cleanChildren, (tab: React.ReactElement<ITabProps>, index: number) => {
		tabs.push(
			<li
				key={"tab-" + tab.props.reactKey}
				className={selectedTab === index ? style.active : ""}
				onClick={() => {
					setSelectedTab(index);
				}}
			>
				{tab.props.label}
			</li>
		);
		let panelClassname: string = selectedTab === index ? "" : "hidden";
		if (!isNullOrEmpty(tab.props.className)) {
			panelClassname += (!isNullOrEmpty(panelClassname) ? " " : "") + tab.props.className;
		}
		panels.push(
			<div key={"tabBody-" + tab.props.reactKey} className={panelClassname}>
				{tab}
			</div>
		);
	});

	return (
		<div className="d-flex flex-column" style={props.style}>
			{tabs.length > 1 ? (
				<div className={style.tabBar} style={props.tabBarStyle}>
					<ul>{tabs}</ul>
				</div>
			) : (
				<div className={style.titleBar}>{cleanChildren[0].props.label}</div>
			)}
			<div className={"flex-grow-1 " + style.tabBarContainer} style={props.tabStyle}>
				{panels}
			</div>
		</div>
	);
};

export default TabPanel;
export { Tab };
